import React from 'react';
import { DotLoader } from '../../atoms';
import './button.scss';

function Button({ type, className, name, label, handleClick, disabled = false,loader = false }) {
  const btnClass = disabled ? 'button-disabled' : className;

  return (
    <button
      type={type}
      className={`button-default ${btnClass}`}
      value={label}
      name={name}
      onClick={handleClick}
      disabled={disabled}
    >
      {label}
      {loader ? (<DotLoader/>) : null}
    </button>
  );
}

export default Button;
